import { IRadioButton } from '@common/types/element';
import { get } from 'lodash';
import React, { FC, useMemo, useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { TouchableOpacity } from 'react-native';
import { setFormValue } from '@common/redux/slice/formInputs';
import Icon from 'react-native-vector-icons/MaterialIcons';

const RadioButton: FC<IRadioButton> = (attributes) => {
  const dispatch = useDispatch();
  const { id } = attributes;
  const [state] = useState({
    activeColor: attributes?.activeColor || '',
    inactiveColor: attributes?.inactiveColor || '',
    activeIcon: attributes?.activeIcon || 'radio-button-checked',
    inactiveIcon: attributes?.inactiveIcon || 'radio-button-unchecked',
  });

  const valueInputs = useMemo(
    () => get(attributes, `dependencies.valueFormInputs.${id}`, false),
    [attributes.dependencies, id]
  );

  const changeValue = useCallback(
    (value: any) => {
      dispatch(setFormValue({ [attributes.id]: value }));
    },
    [dispatch, attributes.id]
  );

  return (
    <TouchableOpacity
      onPress={() => {
        changeValue(!valueInputs);
      }}
      activeOpacity={0.4}
      hitSlop={{ left: 10, right: 10, top: 10, bottom: 10 }}
    >
      <Icon
        size={24}
        name={valueInputs ? state.activeIcon : state.inactiveIcon}
        color={valueInputs ? state.activeColor : state.inactiveColor}
      />
    </TouchableOpacity>
  );
};

export default RadioButton;
